import { libraryActions } from "./LibraryAction";

const initState = {
    loadingFlags: {
        course: true,
        document: true,
        video: true
    },
    errors: {},
    documentIds: [],
    videoIds: []
};

export default function PageReducer(state = initState, action) {
    switch (action.type) {
        case libraryActions.setError:
            return setError(state, action);
        case libraryActions.toggleSpinner:
            return toggleSpinner(state, action);
        case libraryActions.setDocumentIds:
            return setDocumentIds(state, action);
        case libraryActions.setVideoIds:
            return setVideoIds(state, action);
        default:
            return state;
    }
}

function setVideoIds(state, { payload }) {
    const videoIds = payload;
    return {
        ...state,
        videoIds
    };
}

function setDocumentIds(state, { payload }) {
    const documentIds = payload;
    return {
        ...state,
        documentIds
    };
}

function setError(state, { payload, meta }) {
    return {
        ...state,
        errors: {
            [meta.apiName]: payload
        }
    };
}

function toggleSpinner(state, { payload, meta }) {
    return {
        ...state,
        loadingFlags: {
            ...state.loadingFlags,
            [meta.apiName]: payload
        }
    };
}
